import { useQuery } from "react-query";
import axios from "axios";

const getManufacturers = async () => {
    const requestOptions = {
        headers: { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_APIM_KEY }
    };
    const rows = [];
    var api_url = `${process.env.REACT_APP_APIM_URL}/web-get-manufacturers?bc=${process.env.REACT_APP_SBOAT}`;
    console.log(api_url);

    const { data } = await axios.get(api_url, requestOptions);
    data.data.rows.forEach((man) => {
        let manufactures = {
            label: `${man.NAME} (${man.MFR})`,
            id: man.MFR,
        };

        rows.push(manufactures);
    });
    return rows;
};

export default function useManufacturers() {
    return useQuery("manufacturers", getManufacturers);
}
